import { ROUTE } from "../../../routes";
export const navigateToNext = async (action, _datastore, { navigateToBase }) => {
    setTimeout(() => {
        navigateToBase(ROUTE.UNLOCK_LIMIT_LANDING);
    }, 3000);
};
